<nav class="breadcrumb-wrapper">
  <ul class="breadcrumb">
    <span #breadcrumb class="breadcrumb-title">{{ getTranslate(breadcrumbs[breadcrumbs?.length - 1].label) }}</span>
    @if (breadcrumbs.length - 1 !== 0) {
      <span class="separator">
        @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last) {
          <li class="breadcrumb-label">
            @if (!last) {
              <span class="breadcrumb-link">
                @if (breadcrumb.url) {
                  <a [routerLink]="breadcrumb.url">{{ getTranslate(breadcrumb.label) }}</a>
                }
                @if (!breadcrumb.url) {
                  <span>{{ getTranslate(breadcrumb.label) }}</span>
                }
              </span>
            }
            @if (last) {
              <span>{{ getTranslate(breadcrumb.label) }}</span>
            }
          </li>
        }
      </span>
    }
  </ul>
</nav>

<ng-template #templateBreadcrumb let-popover="popover">
  <h2>{{ 'labels.menus.Breadcrumbs' | translate }}</h2>
  <p class="mw300">{{ "labels.text.User's current location" | translate }}</p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button mat-raised-button color="warn" (click)="popover.close(); configurationWizardService.closeConfigWizard()">
      {{ 'labels.buttons.Close' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); previousStep()">
      {{ 'labels.buttons.Back' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="popover.close(); nextStep()">
      {{ 'labels.buttons.Next' | translate }}
    </button>
  </div>
</ng-template>
